var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loadFonts } from "./loadFonts";
const moduleLookupMap = {};
const loadModule = (module, config) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    moduleLookupMap[module.id] = module;
    const isEsModule = module.id.toString().startsWith("nxm_") || ((_a = module.url) === null || _a === void 0 ? void 0 : _a.endsWith(".mjs")) === true;
    const fileExtension = isEsModule ? "mjs" : "js";
    const moduleSrc = ((_b = module.url) !== null && _b !== void 0 ? _b : "") || `${config.modulePath}${module.id}/${module.id}.${fileExtension}`;
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.type = isEsModule ? "module" : "text/javascript";
        script.onload = () => {
            resolve();
        };
        script.onerror = () => {
            reject(moduleSrc);
        };
        script.src = moduleSrc;
        document.body.appendChild(script);
    });
});
const onLoadFail = (reason) => {
    console.log("Module load failed: " + reason);
};
export const loadModules = (config, priorityRange, dependencies) => __awaiter(void 0, void 0, void 0, function* () {
    yield loadFonts(dependencies, config, priorityRange);
    const { modules } = config;
    const modulesWithinPriorityRange = modules.filter((module) => {
        return module.priority >= priorityRange[0] && module.priority <= priorityRange[1];
    });
    modulesWithinPriorityRange.sort((a, b) => {
        return a.priority - b.priority;
    });
    let loadQueue = [];
    for (let i = 0; i < modulesWithinPriorityRange.length; i++) {
        const module = modulesWithinPriorityRange[i];
        loadQueue.push(loadModule(module, config).catch(onLoadFail));
        if (i === modulesWithinPriorityRange.length - 1 || modulesWithinPriorityRange[i + 1].priority > module.priority) {
            yield Promise.all(loadQueue);
            loadQueue = [];
        }
    }
});
export const getModuleParameter = (moduleId, parameterName) => {
    const moduleSpecs = moduleLookupMap[moduleId];
    if (moduleSpecs === undefined) {
        return null;
    }
    return moduleSpecs[parameterName];
};
